/* function share button */
function shareButton(width, height, link) {
    var leftPosition, topPosition;
    leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
    topPosition = (window.screen.height / 2) - ((height / 2) + 50);
    var windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
    window.open(link, '', windowFeatures);
    return false;
}

/* get meta of page */
function getMetaContent(propName) {
	var metas = document.getElementsByTagName('meta');

	for (i = 0; i < metas.length; i++) {
		if (metas[i].getAttribute("name") == propName) {
			return metas[i].getAttribute("content");
		}
	}
	return "";
}

$(document).ready(function(){
    //scroll custom milestone
    if($(".cards-milestone").length >= 1) {
        $('.cards-milestone').each(function(){ 
            var psMilestones = new PerfectScrollbar($(this)[0]); 

            $(window).resize(function(event) {
                psMilestones.update($(this)[0]);
            });
        });
    }

    //scroll custom cards images
    if($(".cards-image").length >= 1) {
        $('.cards-image').each(function(){ 
            var psImagess = new PerfectScrollbar($(this)[0]); 

            $(window).resize(function(event) {
                psImagess.update($(this)[0]);
            });
        });
    }

    //testimonial
    if($(".testimonial-slides").length >= 1) {
        $('.testimonial-slides').slick({
            arrows: false,
            dots: true,
            infinite: true,
            autoplay: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true
        });
    }

    //slideshow
    if($(".slides-text").length >= 1) {
        $('.slides-text').slick({
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        }); 
    }
});

//set width cards milestone, card images, card people
function milestoneWidth(){
    //get width browser
    var getWidthBrowser = $(window).width();

    if(getWidthBrowser >= 1201){
        var gapSlide = ((getWidthBrowser - 1200) / 2);
        getWidthBrowser = getWidthBrowser;
    } else{
        var gapSlide = 20;
        getWidthBrowser = getWidthBrowser;
    }
    $('.list-milestones, .list-images, .lists-column-3').css('width', getWidthBrowser);
    $('.list-milestones ul li:first-child a, .list-images ul li:first-child a').css( "margin-left", gapSlide );
    $('.list-milestones ul li:last-child a, .list-images ul li:last-child a').css( "margin-right", gapSlide );
};
$(document).ready(function() {
    milestoneWidth();
});
$(function(){ 
    $(window).resize(function(event) {
        milestoneWidth();
    });
});

/* share socmed */
$(document).ready(function(){
	var vwidth = 500;
	$('a.socmed-link').click(function(e){
		e.preventDefault();

        var href, getRel, getDesc, getTitle;
		getRel = $(this).attr("rel");
		getDesc = getMetaContent("description");
		getTitle = encodeURI(document.title);

		if (getRel){
			switch(getRel){
				case 'twitter':
                    //https://twitter.com/share?url=url&text=
					href = 'https://twitter.com/share?text='+getTitle+'&url='+encodeURIComponent(window.location);
					break;

				case 'facebook':
					//href = "https://facebook.com/share.php?s=100&p[url]="+encodeURIComponent(window.location)+"&p[title]="+getTitle+"&p[summary]="+getDesc;
					href = "https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(window.location)+"&t="+getTitle;
					break;
			}
		}

		//var href = $(this).attr("href");
		var x = screen.width/2 - vwidth/2;
		var y = screen.height/2 - vwidth/2;
		window.open(href, '_blank', 'height='+vwidth+',width='+vwidth+',left='+x+',top='+y);
	});
});

/* copy url */
var $temp = $("<input>");
var $url = $(location).attr('href');
$('.socmed-copy').on('click', function() {
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();

    $(".status-copied").text("URL copied!");
    $('.status-copied').show();

    $('.status-copied').delay(1000).hide(100); 
})

// show hide navigation depending on scroll direction
$(document).ready(function () {
    var lastScrollTop = 0;
    headerClassInit(true);

    $(window).scroll(function (event) {
        headerClassInit();
    });

    function headerClassInit(firstInit=false) {
        var st = $(this).scrollTop();
        if (st > $("#top-nav").height()) {
                if (st > lastScrollTop) {
                    $("#top-nav").addClass("nav-down").removeClass("nav-up");
                } else {
                    $("#top-nav").removeClass("nav-down").addClass("nav-up");
                }
        } else {
                $("#top-nav").removeClass("nav-up").removeClass("nav-down");
        }
        lastScrollTop = st;
    }
});

//mobile nav
$(".button-mobile-nav").on("click", function(){
    $("body").addClass('overflow-hidden');
    $(".lists-nav").addClass('show-nav-mobile');
    
    $(this).hide();
    $(".button-mobile-nav-close").show();
});
$(".button-mobile-nav-close").on("click", function(){
    $("body").removeClass('overflow-hidden');
    $(".lists-nav").removeClass('show-nav-mobile');

    $(this).hide();
    $(".button-mobile-nav").show();
});

//overlay
$(".profile-overlay").click(function() {
    //get value from attr id current
    var getValID = $(this).attr("id");

    $('body').addClass('overflow-hidden');
    $('#profile-'+getValID).addClass('show');
});
$(".close-profile").click(function() {
    $('body').removeClass('overflow-hidden');
    $('.overlay-profile').removeClass('show');
});

//add to content container
var listContent = '';
var getH3 = Sizzle('.text .right-content h3');
for( var i = 0; i < getH3.length; i++ ) {
    if(i==0){
        listContent += "<li data='#to"+i+"' class='active to"+i+"'><a href='#to"+i+"'>" + getH3[i].innerHTML + "</a></li>";
    } else{
        listContent += "<li data='#to"+i+"' class='to"+i+"'><a href='#to"+i+"'>" + getH3[i].innerHTML + "</a></li>";
    }
}
if($("#content-lists-banner").length == 1) {
    document.getElementById('content-lists-banner').innerHTML = listContent;
}
if($("#content-lists").length == 1) {
    document.getElementById('content-lists').innerHTML = listContent;
}

document.querySelectorAll('.text .right-content h3').forEach(function(el, i){
    el.id = 'to'+i; //added id
    //el.classList.add('sampleClass'); added class
});

/* anchor contents */
$(document).ready(function(){
    /* call function scroll */
    $(document).on("scroll", onScroll);

	$('ul#content-lists li a, ul#content-lists-banner li a').bind('click',function(event){
        var url = $(this).attr('href');
		var anchor = url.substring(url.indexOf('#'));
        $('html, body').stop().animate({
			scrollTop: $(anchor).offset().top - 100
		}, 800);

		/* add class active to li of a clicked */
        $('ul.content-lists li').removeClass('active');
        $(this).parent().addClass('active');

        /* call function scroll */
        $(document).on("scroll", onScroll);

        /* sync from 2 place, banner and left nav content */
        var sync2place = anchor.replace("#", ""); 
        if ( $("ul.content-lists li."+sync2place).length ) {
            $("ul.content-lists li."+sync2place).addClass('active');
        }

        event.preventDefault();
	});
});

//left nav text plain
function onScroll(event){
    var scrollPos = $(document).scrollTop();
    $('#left-content-text-plain li').each(function(){
        var currLink = $(this);
        var refElement = $(currLink.attr("data"));
        var positionOnTop = refElement.position().top - 100;
        if (positionOnTop <= scrollPos && positionOnTop + refElement.height() > scrollPos) {
            $('#left-content-text-plain ul li').removeClass("active");
            currLink.addClass("active");
        }
        else{
            //currLink.removeClass("active");
        }
    });
};

/* filter article 
$('.filter-article ul li').on("click", function(e){
    $('ul li').hide();
    
    $(this).show();
    $('.filter-article ul li span.value').hide();
    $('.close-filter-article').show();

    e.preventDefault();
});
$('.close-filter-article').on("click", function(e){
    $('.close-filter-article').hide();

    $('.filter-article ul li span.value').show();
    $('.filter-article ul li').show();

    e.preventDefault();
}); */